var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2ZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8 60.5L48.1 45.3a20 20 0 10-33.6-14.7 20 20 0 0020 20 20.4 20.4 0 008.6-1.9l13.1 15.6a2.8 2.8 0 002.7 1 2.4 2.4 0 001.5-.6 2.9 2.9 0 00.4-4.2zM18.5 30.6a16 16 0 1116 16 16 16 0 01-16-16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4 33h-7v7h-4v-7h-7v-4h7v-7h4v7h7z"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Zoom_in.45c82e76.svg";
export { SvgJ2ZoomIn as ReactComponent };